import { isSupportedLanguage, LanguageLoacle } from '@/i18n';
import { format, isThisYear, isToday, isYesterday } from 'date-fns';
import { formatDistanceToNowStrict } from 'date-fns/formatDistanceToNowStrict';
import { enUS, zhCN, zhHK } from 'date-fns/locale';

const locales = { enUS, zhCN, zhHK };

export function formatDistanceToNow(date: Date, lang: string) {
    return formatDistanceToNowStrict(date, {
        addSuffix: true,
        locale: isSupportedLanguage(lang) ? locales[LanguageLoacle[lang]] : locales.enUS,
    });
}

export function formatFriendlyDate(date: string | Date | number): string {
    const d = new Date(date);
    if (isNaN(d.getTime())) return '-';

    if (isToday(d)) {
        return `Today, ${format(d, 'h:mm a')}`;
    }

    if (isYesterday(d)) {
        return `Yesterday, ${format(d, 'h:mm a')}`;
    }

    if (isThisYear(d)) {
        return format(d, 'MMM d, h:mm a');
    }

    return format(d, 'MMM d, yyyy, h:mm a');
}

/**
 * Format date portion only (e.g., "Oct 12" or "Oct 12, 2024")
 * Uses padded day for consistent width
 */
export function formatDatePart(date: string | Date | number): string {
    const d = new Date(date);
    if (isNaN(d.getTime())) return '-';

    if (isThisYear(d)) {
        return format(d, 'MMM dd');
    }

    return format(d, 'MMM dd, yyyy');
}

/**
 * Format time portion only (e.g., "12:00 AM")
 */
export function formatTimePart(date: string | Date | number): string {
    const d = new Date(date);
    if (isNaN(d.getTime())) return '-';

    return format(d, 'hh:mm a');
}
